export default __webpack_public_path__ + "static/media/left_mildArch.9df10a4c.png";